<div class="panel d-flex">
  <div class="panel-content">
    <h2 class="mb-3 text-bold" i18n="@@fees.crypto.receive.title">Receiving Cryptocurrency</h2>
    <p class="text-md" i18n="@@fees.crypto.receive.info">Transferring cryptocurrencies from an external wallet or exchange to your BitOasis account is free.</p>
  </div>
  <div class="p-2"></div>
  <badge-component class="col-lg-4 col-md-4 col-12"
    title="Receiving Fees"
    i18n-title="@@fees.badge.crypto.title"
    content="0% - Zero Fees"
    i18n-content="@@fees.badge.deposit.content.zero"
  ></badge-component>
</div>
<div class="panel d-flex">
  <div class="panel-content w-100">
    <h2 class="mb-3 text-bold" i18n="@@fees.crypto.send.title">Sending Cryptocurrency</h2>
    <p class="text-md" i18n="@@fees.crypto.send.info">As with all blockchain transactions, sending crypto from BitOasis to external wallets will carry a fee depending on the cryptocurrency and the network.</p>
    <div class="search-table">
      <search-crypto-fee-component
        [items]="withdrawalFees"
        [filteredFields]="['currency', 'name']"
        (getFilteredData)="filterSendingCrypto($event)"
        [searchValue]="searchValue"
        light="true"
      ></search-crypto-fee-component>
      <carousel-component [dotsAmount]="filteredWithdrawalFees.length">
        <ng-template #header>
          <table class="general">
            <tr class="header">
              <th i18n="@@fees.crypto.table.asset">Digital Asset</th>
              <th i18n="@@fees.crypto.table.maker">Fee per Sending</th>
              <th i18n="@@fees.crypto.table.taker">Minimum Sending amount</th>
            </tr>
          </table>
          <div class="empty-table" *ngIf="searchValue?.length && !filteredWithdrawalFees[0]?.length">
            <p i18n="@@tokens.search.nothing">Nothing found for “{{searchValue}}”</p>
            <button class="btn btn-link" (click)="clearSearchValue()" i18n="core2.currencyModal.empty.action">Clear search</button>
          </div>
        </ng-template>
        <ng-template #scrollable>
          <table *ngFor="let group of filteredWithdrawalFees;" class="general rows-group">
            <tr *ngFor="let fee of group;">
              <td>
                <div class="crypto-td" *ngIf="fee?.currency">
                  <currency [currency]="fee.currency"></currency>
                  <div class="p-1"></div>
                  <div>
                    {{fee.currency}}
                    <div class="text-sm">{{fee.name}}</div>
                  </div>
                </div>
              </td>
              <td>{{fee?.amount?.amount | number:'0.2-6'}} {{fee?.amount?.currency}}</td>
              <td>{{fee?.minAmount?.amount | number:'0.2-6'}} {{fee?.minAmount?.currency}}</td>
            </tr>
          </table>
        </ng-template>
      </carousel-component>
    </div>
    <p class="mt-5" i18n="@@fees.crypto.send.note"><strong>Note:</strong> To ensure that your transactions are processed within a reasonable time, our sending fees for each cryptocurrency are subject to changes to account for any congestion on the blockchain.</p>
  </div>
</div>
